import React from 'react';

export default function SellSection({ theme = 'light' }) {
  const isDark = theme === 'dark';

  return (
    <div className="flex flex-col gap-y-1 text-sm">
      <h4 className={`font-semibold mb-0 ${isDark ? 'text-white' : ''}`}>Sell</h4>
      <ul className={isDark ? 'text-gray-400' : 'text-content-secondary'}>
        {[
          {
            title: 'Sell by Dealer Bidding',
            url: '/sell-my-car-online-to-dealer-singapore/',
          },
          {
            title: 'Sell by Consignment',
            url: '/consign-a-car/',
          },
          {
            title: 'Export/Scrap Car',
            url: '/scrap-car-singapore/',
          },
          {
            title: 'Get a Car Valuation',
            url: '/car-valuation-singapore/',
          },
          {
            title: 'Deregister Car',
            url: '/deregister-your-car/',
          },
          {
            title: 'Trade In Car',
            url: '/trade-in-your-car/',
          },
        ].map((item) => (
          <li key={item.title}>
            <a
              className={`${isDark ? 'text-gray-400 visited:text-gray-400' : 'text-content-secondary visited:text-content-secondary'} leading-relaxed hover:text-gray-300`}
              href={item.url}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
